import * as React from 'react';

import GridOneCol from '@src/components/Grid/GridOneCol';
import PageSection from '@src/components/PageSection';
import {graphql} from 'gatsby';

import * as styles from './frameEmbed.module.scss';

import type {IFrameEmbedFragment as IFrameEmbedFragmentType} from '@graphql-types';

interface FrameEmbedProps {
  frameEmbedContent: IFrameEmbedFragmentType;
}

const IFrameEmbed: React.FC<FrameEmbedProps> = props => (
  <PageSection>
    <GridOneCol gridType="full" align="left">
      <div className={styles.wrapper}>
        <iframe
          className={styles.iFrame}
          src={props.frameEmbedContent.primary.iframe_embed.text}
          name="iframe"
          width="560"
          height="315"
          allowFullScreen={true}
        />
      </div>
    </GridOneCol>
  </PageSection>
);

export default IFrameEmbed;

export const IFrameEmbedFragment = graphql`
  fragment iFrameEmbed on PrismicPageDataBodyIframeEmbed {
    id
    slice_type
    primary {
      iframe_embed {
        text
      }
    }
  }
`;
